import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBankRound = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20.4434,
			r: 20,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20.4434,
			r: 20,
			fill: "#262626"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_9822_251551)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M28.3334 27.7767H27.5V21.1092C28.42 21.1059 29.1667 20.3575 29.1667 19.4367C29.1667 18.8234 28.8317 18.26 28.2942 17.9684L21.1242 14.0575C21.0309 14.0067 20.93 13.98 20.8325 13.9434V13.0934L23.0284 11.7309C23.4409 11.4559 23.4317 10.8475 23.0117 10.585L20.96 9.62253C20.7725 9.50503 20.5559 9.44336 20.3342 9.44336C19.6825 9.44336 19.1534 9.97169 19.1534 10.6242V13.61H19.1659V13.9434C19.0684 13.9809 18.9675 14.0067 18.8742 14.0575L11.7059 17.9684C11.1675 18.2609 10.8334 18.8225 10.8334 19.4367C10.8334 20.3575 11.5809 21.1059 12.5 21.1092L12.5 27.7767H11.6667C11.2067 27.7767 10.8334 28.1492 10.8334 28.61C10.8334 29.0709 11.2067 29.4434 11.6667 29.4434H28.3334C28.7942 29.4434 29.1667 29.0709 29.1667 28.61C29.1667 28.1492 28.7942 27.7767 28.3334 27.7767ZM19.1667 21.11V27.7767H17.5V21.11H19.1667ZM20.8334 21.11H22.5V27.7767H20.8334V21.11ZM24.1667 21.11H25.8334V27.7767H24.1667V21.11ZM14.1667 21.11H15.8334V27.7767H14.1667V21.11Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_9822_251551",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white",
				transform: "translate(10 9.44336)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgBankRound);
export default ForwardRef;
